const Experience = () => {
  const experience = [
    {
      company: 'Clickstream, LLC',
      role: 'Chief Technical Officer',
      period: 'Jan 2026 - Present',
      description: 'Leading engineering for a behavioral analytics and identity resolution platform. Building edge-computed real-time scoring, fraud detection, and multi-touch attribution systems.',
    },
    {
      company: 'Data Control Corporation',
      role: 'Software Engineer',
      period: 'Jul 2025 - Nov 2025',
      description: 'Architected fully automated AI/ML ETL pipeline with custom LLMs. Established robust data architecture for ML consumption.',
    },
    {
      company: 'Quantum Sentinel',
      role: 'Co-Founder / Lead Engineer',
      period: 'Dec 2024 - Jul 2025',
      description: 'Spearheaded high-performance SIGINT frameworks for zero-click vulnerabilities. Designed quantum-enabled communication security research systems.',
    },
    {
      company: 'SIPPIO',
      role: 'Software & Security Engineer Intern',
      period: 'May 2024 - Aug 2024',
      description: 'Implemented comprehensive security policies (GDPR, SOC2, HIPAA). Led penetration testing on telecom platform.',
    },
  ];

  return (
    <section id="experience" className="section-padding bg-bg-dark">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-6 md:mb-12">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-2 md:mb-4">
            Recent <span className="gradient-text">Experience</span>
          </h2>
          <p className="text-sm md:text-lg text-text-secondary max-w-2xl mx-auto">
            Building cutting-edge systems across AI/ML, quantum computing, and cybersecurity
          </p>
        </div>

        {/* Experience Timeline */}
        <div className="max-w-4xl mx-auto space-y-4 md:space-y-8">
          {experience.map((exp, index) => (
            <div
              key={index}
              className="glass p-4 md:p-6 rounded-xl hover:border-quantum-blue transition-all duration-300"
            >
              <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2 md:mb-3">
                <h4 className="text-base md:text-xl font-heading font-semibold text-quantum-blue">
                  {exp.company}
                </h4>
                <span className="text-text-secondary text-xs md:text-sm">{exp.period}</span>
              </div>
              <p className="text-sm md:text-lg font-medium mb-1 md:mb-2">{exp.role}</p>
              <p className="text-text-secondary text-sm md:text-base leading-relaxed">{exp.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
